// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  align-items: center;
  display: inline-flex;
  justify-content: center;
}

:host(.display) {
  height: 100%;
  width: 100%;
}

:host(.size-button.display) {
  width: auto;
  height: auto;
}

:host(.overlay.display) {
  /* stylelint-disable-next-line stylelint-plugins/no-hardcoded-colors */
  background: rgba(1, 1, 1, 0.3);
  left: 0;
  position: absolute;
  top: 0;
  z-index: 5;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNwaW5uZXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxtQkFBQTtFQUNBLG9CQUFBO0VBQ0EsdUJBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7RUFDQSxXQUFBO0FBQ0Y7O0FBRUE7RUFDRSxXQUFBO0VBQ0EsWUFBQTtBQUNGOztBQUVBO0VBQ0Usc0VBQUE7RUFDQSw4QkFBQTtFQUNBLE9BQUE7RUFDQSxrQkFBQTtFQUNBLE1BQUE7RUFDQSxVQUFBO0FBQ0YiLCJmaWxlIjoic3Bpbm5lci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xufVxuXG46aG9zdCguZGlzcGxheSkge1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG46aG9zdCguc2l6ZS1idXR0b24uZGlzcGxheSkge1xuICB3aWR0aDogYXV0bztcbiAgaGVpZ2h0OiBhdXRvO1xufVxuXG46aG9zdCgub3ZlcmxheS5kaXNwbGF5KSB7XG4gIC8qIHN0eWxlbGludC1kaXNhYmxlLW5leHQtbGluZSBzdHlsZWxpbnQtcGx1Z2lucy9uby1oYXJkY29kZWQtY29sb3JzICovXG4gIGJhY2tncm91bmQ6IHJnYmEoMSwgMSwgMSwgMC4zKTtcbiAgbGVmdDogMDtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDA7XG4gIHotaW5kZXg6IDU7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./libs/shared/ng/base/src/lib/base/spinner/spinner.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,sEAAA;EACA,8BAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AACF;AACA,4/BAA4/B","sourcesContent":[":host {\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n}\n\n:host(.display) {\n  height: 100%;\n  width: 100%;\n}\n\n:host(.size-button.display) {\n  width: auto;\n  height: auto;\n}\n\n:host(.overlay.display) {\n  /* stylelint-disable-next-line stylelint-plugins/no-hardcoded-colors */\n  background: rgba(1, 1, 1, 0.3);\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
